import { ContactPerson } from '../types/contactPerson'

export const placePrimaryContactFirst = (contactPersons: ContactPerson[]): ContactPerson[] => {
  const primaryContact = contactPersons.find((c) => c.isPrimary)

  if (!primaryContact) {
    return contactPersons
  }

  const contactPersonsWithoutPrimary = contactPersons.filter((c) => c !== primaryContact)

  return [primaryContact, ...contactPersonsWithoutPrimary]
}
